import './GenericTabs.css';

import React, { useEffect, useState } from 'react';
import { Tab, Tabs } from '@mui/material';
import PropTypes from 'prop-types';
import { generateClassName } from './helpers';
import GenericTabPanel from './GenericTabPanel';
import { isEqualWith } from 'lodash';

const GenericTabs = ({ tabsConfig, className = null, onSelectedTab = null }) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const [currentTabsConfig, setCurrentTabsConfig] = useState(null);

    const [dummyState, setDummyState] = useState(0);

    const customizer = (objValue, othValue, key) => {
        if (key === 'content') {
            return true;
        }
    };

    useEffect(() => {
        if (!isEqualWith(tabsConfig, currentTabsConfig, customizer)) {
            setSelectedTab(0);
            setDummyState(dummyState + 1);
        }
        setCurrentTabsConfig(tabsConfig);
    }, [tabsConfig]);


    if (!currentTabsConfig || currentTabsConfig.length === 0) {
        return null;
    }

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        if (onSelectedTab) {
            onSelectedTab(newValue);
        }
    };

    return (
        <div className={generateClassName('generic', '-tabs', className)}>
            <div className={generateClassName('generic', '-tabs-header', className)}>
                <Tabs value={selectedTab} onChange={handleTabChange}>
                    {currentTabsConfig.map((tab, index) => (
                        tab.showTab !== false && (
                            <Tab key={index} label={tab.label} icon={tab.icon} className={generateClassName('generic', '-tab', className)} />
                        )
                    ))}
                </Tabs>
            </div>
            <div className={generateClassName('generic', '-tabs-content', className)} >
                {currentTabsConfig.map((tab, index) => (
                    tab.showTab !== false && (
                        <div
                            key={index}
                            role="tabpanel"
                            hidden={selectedTab !== index}
                            id={`tabpanel-${index}`}
                            aria-labelledby={`tab-${index}`}
                        >
                            {selectedTab === index && (
                                <GenericTabPanel key={index} value={selectedTab} index={index} className={className}>
                                    {tab.content}
                                </GenericTabPanel>
                            )}
                        </div>
                    )
                ))}
            </div>
        </div>
    );
};

GenericTabs.propTypes = {
    tabsConfig: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            icon: PropTypes.element,
            content: PropTypes.element.isRequired,
            showTab: PropTypes.bool
        })
    )
};

GenericTabs.defaultProps = {
    tabsConfig: [
        {
            showTab: true
        }
    ]
};

export default GenericTabs;